import { Checkbox, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOffice941TotalsReport extends Layout {
    checkboxIncludeSettlements: Checkbox;
    checkboxReverseVoids: Checkbox;
    sourceOffice941TotalsReports: DataSource;
    textboxDateRange: Textbox;
}
